import React from 'react';
import {observer} from 'mobx-react';

import {useStores} from '../../stores/use-stores';

import PromotionsListScreenBase from './PromotionsListScreenBase';

const PromotionsDrawnWinnersListScreen = observer(() => {
  const {promotionsStore: activationsStore} = useStores();
  const promotions = activationsStore.drawnWinnersPromotions;

  return <PromotionsListScreenBase promotions={promotions} />;
});

export default PromotionsDrawnWinnersListScreen;
